<template>
	<v-expansion-panel :value="0" expand class="elevation-0 mb-0">

		<template v-for="(data, type, index) in probe">
			<template v-if="!Array.isArray(data)">
				<v-expansion-panel-content
					class="background darken-1 mt-1"
					:key="type + index">
					<template v-slot:header>
						<div>
							<v-chip
								label small
								color="background"
								class="my-0 subheading text-capitalize">
								{{ type }}
							</v-chip>
							<v-chip
								label small outline
								color="background lighten-5"
								class="my-0"
								v-if="type === 'format'">
								{{ data.format_long_name }}
							</v-chip>
						</div>
					</template>
					<v-card class="background">
						<v-card-text class="pa-0">
							<table class="table-probe">
								<tbody>
									<tr
										v-for="(value, key, index) in data"
										:key="key + index">
										<td>{{ key }}</td>
										<td v-if="$commons.isObject(value)">
											<ul>
												<li
													v-for="(subValue, subKey, SubIndex) in value"
													:key="subKey + SubIndex">
													{{ subKey }} : {{ subValue }}
												</li>
											</ul>
										</td>
										<td v-else>{{ value }}</td>
									</tr>
								</tbody>
							</table>
						</v-card-text>
					</v-card>
				</v-expansion-panel-content>
			</template>
			<template v-else>
				<template v-for="(stream, streamIndex) in data">
					<v-expansion-panel-content
						class="background darken-1 mt-1"
						v-if="true"
						:key="'stream' + streamIndex + type">
						<template v-slot:header>
							<div>
								<v-chip
									label small
									color="background"
									class="my-0 subheading">
									Stream {{ stream.codec_type }}
								</v-chip>
								<v-chip
									label small outline
									color="background lighten-5"
									class="my-0"
									v-if="stream.codec_type === 'video'">
									{{ stream.codec_name }}
								</v-chip>
								<v-chip
									label small outline
									color="background lighten-5"
									class="my-0"
									v-else-if="stream.codec_type === 'audio'">
									{{ stream.channels }} Channel
								</v-chip>
								<v-chip
									label small outline
									color="background lighten-5"
									class="my-0"
									v-else-if="stream.codec_type === 'data'">
									{{ stream.codec_tag_string }}
								</v-chip>
							</div>
						</template>
						<v-card class="background">
							<v-card-text class="pa-0">
								<table class="table-probe">
									<tbody>
										<tr
											v-for="(value, key, index) in stream"
											:key="key + index">
											<td>{{ key }}</td>
											<td v-if="$commons.isObject(value)">
												<ul>
													<li
														v-for="(subValue, subKey, SubIndex) in value"
														:key="subKey + SubIndex">
														{{ subKey }} : {{ subValue }}
													</li>
												</ul>
											</td>
											<td v-else>{{ value }}</td>
										</tr>
									</tbody>
								</table>
							</v-card-text>
						</v-card>
					</v-expansion-panel-content>
				</template>
			</template>
		</template>

		<!-- <v-expansion-panel-content
			class="background darken-1 mt-1">
			<template v-slot:header>
				<div>
					<v-chip label small color="background" class="my-0 subheading">
						Format
					</v-chip>
					{{ filename }}
				</div>
			</template>
			<v-card class="background">
				<v-card-text class="pa-0">
					<table class="table-probe">
						<tbody>
							<tr
								v-for="(value, key, index) in probe.format"
								:key="key + index">
								<td>{{ key }}</td>
								<td v-if="$commons.isObject(value)">
									<ul>
										<li
											v-for="(subValue, subKey, SubIndex) in value"
											:key="subKey + SubIndex">
											{{ subKey }} : {{ subValue }}
										</li>
									</ul>
								</td>
								<td v-else>{{ value }}</td>
							</tr>
						</tbody>
					</table>
				</v-card-text>
			</v-card>
		</v-expansion-panel-content>
		<template
			v-for="(streamList, streamType, index) in probe">
			<v-expansion-panel-content
				v-for="(stream, streamIndex) in streamList"
				class="background darken-1 mt-1"
				:key="'stream' + streamIndex">
				<template v-slot:header>
					<div>
						<v-chip
							label small
							color="background"
							class="my-0 subheading">
							Stream {{ stream.codec_type }}
						</v-chip>
						<v-chip
							label small outline
							color="background lighten-5"
							class="my-0"
							v-if="stream.codec_type === 'video'">
							{{ stream.codec_name }}
						</v-chip>
						<v-chip
							label small outline
							color="background lighten-5"
							class="my-0"
							v-else-if="stream.codec_type === 'audio'">
							{{ stream.channels }} Channel
						</v-chip>
					</div>
				</template>
				<v-card class="background">
					<v-card-text class="pa-0">
						<table class="table-probe">
							<tbody>
								<tr
									v-for="(value, key, index) in stream"
									:key="key + index">
									<td>{{ key }}</td>
									<td v-if="$commons.isObject(value)">
										<ul>
											<li
												v-for="(subValue, subKey, SubIndex) in value"
												:key="subKey + SubIndex">
												{{ subKey }} : {{ subValue }}
											</li>
										</ul>
									</td>
									<td v-else>{{ value }}</td>
								</tr>
							</tbody>
						</table>
					</v-card-text>
				</v-card>
			</v-expansion-panel-content>
		</template> -->
	</v-expansion-panel>
</template>

<script>
export default {
	props: ['probe'],
	computed: {
		filename () {
			let filename = this.$commons.deepGet(this.probe, 'format.filename', '')
			if (filename) {
				filename = filename.replace(/\\/g, '/')
				filename = filename.substring(filename.lastIndexOf('/') + 1)
			}
			return filename
		}
	}
}
</script>

<style scoped lang="stylus">
.table-probe
	width: 100%
	td
		padding: .2em .5em
		vertical-align: top
		&:first-child
			width: 30%
		&:last-child
			width: 70%
		ul
			padding-left: 1em
			list-style-type: disc
	tr:nth-child(odd)
		td
			background-color: var(--v-odd-base)
	tr:nth-child(even)
		td
			background-color: var(--v-even-base)

>>>.v-expansion-panel__header:hover
	background-color: var(--v-background-darken2)

>>>.v-expansion-panel__container
	border-top: none !important
	margin-top: 0 !important

>>>.v-expansion-panel__container:not(:last-child)
	margin-bottom: 3px !important
</style>



// WEBPACK FOOTER //
// src/components/ffprobe_display_nexus.vue